import { Link } from "react-router-dom";
import EditIcon from "../../../Icons/EditIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const TableActionButton = (props: any) => {
  return (
    <Link to={props?.editPath} className={tw`cursor-pointer`}>
      <EditIcon color={"var(--primary)"} />
    </Link>
  );
};

export default TableActionButton;
